import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreakModal from '../../../Scheduler/containers/BreakModal';
import TaskModal from '../../../Scheduler/containers/TaskModal';
import { getModalProps } from '../../store/selectors';

import Modal from 'Containers/Common/Modal';
import RefundModal from 'Containers/Payments/containers/RefundModal';
import ShowInfoPaymentModal from 'Containers/Payments/containers/ShowInfoPaymentModal';
import WorkerRetailModal from 'Containers/Scheduler/containers/SchedulerWorker/WorkerRetailModal';
import WorkerSoldOutModal from 'Containers/Scheduler/containers/SchedulerWorker/WorkerSoldOutModal';
import dayjs from 'dayjs';
import useWindowSize from 'utils/useWindowSize';
import SalonAvatarModal from '../../../Auth/containers/SalonAvatarModal';
import SalonCoverModal from '../../../Auth/containers/SalonCoverModal';
import ClientModal from '../../../Clients/containers/ClientModal';
import ServiceModal from '../../../SalonManagement/containers/Services/containers/ServiceModal';
import ClosuresModal from '../../../SalonManagement/containers/Workers/containers/ClosuresModal';
import ExtraWorkingTimeModal from '../../../SalonManagement/containers/Workers/containers/ExtraWorkingTimeModal';
import WorkerAvatarModal from '../../../SalonManagement/containers/Workers/containers/WorkerAvatarModal';
import WorkerCreationModal from '../../../SalonManagement/containers/Workers/containers/WorkerCreationModal';
import WorkerDescriptionModal from '../../../SalonManagement/containers/Workers/containers/WorkerDescriptionModal';
import WorkerNameModal from '../../../SalonManagement/containers/Workers/containers/WorkerNameModal';
import WorkerWorkTimeOneDayModal from '../../../SalonManagement/containers/Workers/containers/WorkerWorkTimeOneDayModal';
import CalendarHeaderModal from '../../../Scheduler/containers/CalendarHeader/components/CalendarHeaderModal';
import CalendarSettingsModal from '../../../Scheduler/containers/CalendarHeader/components/CalendarSettingsModal';
import PlanModal from '../../../Scheduler/containers/CalendarHeader/components/PlanModal';
import OverlapBookingsModal from '../../../Scheduler/containers/OverlapBookingsModal';
import ClientsQueueModal from '../../../Scheduler/containers/ClientsQueueModal';
import TaskInfoModal from '../../../Scheduler/containers/TaskInfoModal';
import SharedWorkersModal from '../../../Settings/containers/SharingContainer/containers/SharedWorkersModal';
import { modalActions } from '../../store';
import EditSuccessModal from '../EditSuccessModal';
import NewClientModal from '../../../Clients/containers/NewClientModal';
import QRcodeImg from 'Containers/Settings/containers/SharingContainer/containers/QRcodeImg';
import EditSalonIbanModal from '../EditSalonIbanModal';
import WorkerPaymentDaysModal from '../../../SalonManagement/containers/Workers/containers/WorkerPaymentDaysModal';
import WorkerEditServiceModal from 'Containers/SalonManagement/containers/Workers/containers/EditServiceModal';
import JoinServicesModal from 'Containers/SalonManagement/containers/Workers/containers/ServicesList/JoinServicesModal';
import AccountModal from 'Containers/Settings/containers/AccountsManager/AccountModal';
import { useTranslation } from 'react-i18next';
import WrappedModal from '../WrappedModal';
import VerifiedShareModal from '../VerifiedShareModal';

const Component = {
  taskInfoModal: TaskInfoModal,
  addTaskModal: TaskModal,
  breakModal: BreakModal,
  editTaskModal: TaskModal,
  clientsQueueModal: ClientsQueueModal,
  calendarHeaderModal: CalendarHeaderModal,
  calendarSettingsModal: CalendarSettingsModal,
  planModal: PlanModal,
  overlapBookingsModal: OverlapBookingsModal,
  successModal: EditSuccessModal,
  editServiceModal: ServiceModal,
  editWorkerServiceModal: WorkerEditServiceModal,
  createServiceModal: ServiceModal,
  createWorkerModal: WorkerCreationModal,
  editWorkerWorkTimeModalOneDay: WorkerWorkTimeOneDayModal,
  editWorkerNameModal: WorkerNameModal,
  editWorkerDescriptionModal: WorkerDescriptionModal,
  createWorkerAvatarModal: WorkerAvatarModal,
  editWorkerAvatarModal: WorkerAvatarModal,
  workerClosuresModal: ClosuresModal,
  workerClosuresOneDayModal: ClosuresModal,
  workerExtraWorkingTimeModal: ExtraWorkingTimeModal,
  workerExtraWorkingTimeOneDayModal: ExtraWorkingTimeModal,
  createSalonAvatarModal: SalonAvatarModal,
  createSalonCoverModal: SalonCoverModal,
  clientModal: ClientModal,
  refundModal: RefundModal,
  sharedWorkersModal: SharedWorkersModal,
  workerRetailModal: WorkerRetailModal,
  workerSoldOutModal: WorkerSoldOutModal,
  showInfoPaymentModal: ShowInfoPaymentModal,
  createClientModal: NewClientModal,
  qrCodeModal: QRcodeImg,
  editSalonIbanModal: EditSalonIbanModal,
  workerPaymentDaysModal: WorkerPaymentDaysModal,
  joinServicesModal: JoinServicesModal,
  accountModal: AccountModal,
  wrappedModal: WrappedModal,
  verifiedShareModal: VerifiedShareModal,
};

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { type, props, callback } = useSelector(getModalProps());

  const closeAllModals = () => {
    dispatch(modalActions.CLOSE_MODAL.SUCCESS());
  };
  const { isMobile, isTablet } = useWindowSize();
  const isCompactLayout = isMobile || isTablet;

  const modalProps = {
    taskInfoModal: {
      title: `${props?.task?.nome || ''} ${props?.task?.cognome || ''}`.trim(),
      subTitle:
        props?.task?.unixStartTime && props?.task?.unixEndTime
          ? `${dayjs(props.task.unixStartTime * 1000).format('HH:mm')} – ${dayjs(
              props.task.unixEndTime * 1000,
            ).format('HH:mm')}`
          : undefined,
      maxWidth: 'min(420px, calc(100vw - 32px))',
      width: '100%',
      borderRadius: '16px',
      showCloseBtn: true,
    },
    addTaskModal: {
      title: !!isMobile && props?.task?.orario_end ? t('modals.global.addTaskModal.quick') : t('modals.global.addTaskModal.new'),
      maxWidth: '560px',
      width: '560px',
      showCloseBtn: true,
    },
    breakModal: {
      title: t('modals.global.breakModal.title'),
      maxWidth: 'min(440px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '85dvh',
      height: 'auto',
      showCloseBtn: true,
      centered: true,
      borderRadius: '16px',
    },
    editTaskModal: {
      title: t('modals.global.editTaskModal.title'),
      maxWidth: '560px',
      width: '560px',
      showCloseBtn: true,
    },
    clientsQueueModal: {
      title: t('modals.global.clientsQueueModal.title', { count: props?.clientsLength }),
      maxWidth: '520px',
      width: '100%',
      showCloseBtn: true,
    },
    calendarHeaderModal: {
      title: t('modals.global.calendarHeaderModal.title'),
      width: isCompactLayout ? '100%' : 'fit-content',
      maxWidth: isCompactLayout ? '100%' : undefined,
      showCloseBtn: true,
    },
    calendarSettingsModal: {
      title: t('modals.global.calendarSettingsModal.title'),
      maxWidth: '360px',
      width: '100%',
      showCloseBtn: true,
    },
    planModal: {
      title: '',
      maxWidth: 'min(400px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '90dvh',
      height: 'auto',
      showCloseBtn: false,
      centered: true,
      borderRadius: '16px',
      closeOnOverlayClick: false,
    },
    overlapBookingsModal: {
      title: t('modals.global.overlapBookingsModal.title'),
      maxWidth: '400px',
      width: '100%',
      showCloseBtn: true,
    },
    successModal: {
      title: props?.header,
      maxWidth: '370px',
      showCloseBtn: true,
    },
    editServiceModal: {
      title: t('modals.global.serviceInfo.title'),
      maxWidth: '500px',
      width: '500px',
      height: '100vh',
      showCloseBtn: true,
      fullScreen: true,
    },
    editWorkerServiceModal: {
      title: t('modals.global.serviceInfo.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    joinServicesModal: {
      title: t('modals.global.joinServicesModal.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    createServiceModal: {
      title: t('modals.global.serviceInfo.title'),
      maxWidth: '500px',
      width: '500px',
      height: '100vh',
      showCloseBtn: true,
      fullScreen: true,
    },
    createWorkerModal: {
      title: t('modals.global.createWorkerModal.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    editWorkerWorkTimeModalOneDay: {
      title: t('modals.global.selectTime.title'),
      maxWidth: '370px',
      showCloseBtn: true,
    },
    editWorkerNameModal: {
      title: t('modals.global.workerName.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    editWorkerDescriptionModal: {
      title: t('modals.global.workerDescription.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    createWorkerAvatarModal: {
      title: t('modals.global.workerAvatar.create'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    editWorkerAvatarModal: {
      title: t('modals.global.workerAvatar.edit'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    workerClosuresModal: {
      title: `${t('modals.global.selectTime.title')} ${props?.worker ? ` ${t('clients.clientModal.main.with', { name: props?.worker })}` : ''}`,
      maxWidth: '700px',
      showCloseBtn: true,
    },
    workerClosuresOneDayModal: {
      title: `${t('modals.global.selectTime.title')} ${props?.startDay ? `${dayjs(props?.startDay).format('DD/MM/YYYY')}` : ''}`,
      maxWidth: '500px',
      showCloseBtn: true,
    },
    workerExtraWorkingTimeModal: {
      title: `${t('workers.extraWorkingTime.newExtraOpening')}${props?.worker ? ` · ${props.worker}` : ''}`,
      maxWidth: '760px',
      showCloseBtn: true,
    },
    workerExtraWorkingTimeOneDayModal: {
      title: `${t('workers.extraWorkingTime.newExtraOpening')}${props?.startDay ? ` · ${dayjs(props?.startDay).format('DD/MM/YYYY')}` : ''}`,
      maxWidth: '560px',
      showCloseBtn: true,
    },
    createSalonAvatarModal: {
      title: t('modals.global.salonAvatar.create'),
      showCloseBtn: true,
      maxWidth: '500px',
    },
    createSalonCoverModal: {
      title: t('modals.global.salonCover.create'),
      showCloseBtn: true,
      maxWidth: '500px',
    },
    clientModal: {
      title: t('modals.global.clientModal.title'),
      maxWidth: '600px',
      showCloseBtn: true,
    },
    refundModal: {
      title: t('modals.global.refundModal.title'),
      maxWidth: '375px',
      showCloseBtn: true,
    },
    sharedWorkersModal: {
      title: t('modals.global.sharedWorkersModal.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    workerRetailModal: {
      title: props?.worker?.workerName || t('modals.global.workerRetailModal.title'),
      maxWidth: 'min(360px, calc(100vw - 32px))',
      width: '100%',
      showCloseBtn: true,
      centered: true,
      borderRadius: '16px',
    },
    workerSoldOutModal: {
      title: '',
      showCloseBtn: false,
      maxWidth: 'min(440px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '90vh',
      height: 'auto',
      centered: true,
      borderRadius: '16px',
      dark: true,
    },
    showInfoPaymentModal: {
      title: t('modals.global.showInfoPaymentModal.title'),
      maxWidth: '400px',
      showCloseBtn: true,
      background: '#f5f5f5',
      fullScreen: false,
    },
    createClientModal: {
      title: t('modals.global.createClientModal.title'),
      maxWidth: 'min(480px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '85vh',
      height: 'auto',
      showCloseBtn: true,
      centered: true,
      borderRadius: '16px',
    },
    qrCodeModal: {
      title: t('modals.global.qrCodeModal.title'),
      maxWidth: 'min(360px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '90vh',
      height: 'auto',
      showCloseBtn: true,
      centered: true,
    },
    editSalonIbanModal: {
      title: props?.title ?? t('modals.iban.fields.holder.label'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    workerPaymentDaysModal: {
      title: t('modals.global.workerPaymentDaysModal.title'),
      maxWidth: '500px',
      showCloseBtn: true,
    },
    accountModal: {
      title: props?.account ? t('modals.global.accountModal.edit') : t('modals.global.accountModal.new'),
      maxWidth: '500px',
      width: '500px',
      height: '100vh',
      showCloseBtn: true,
      fullScreen: true,
    },
    wrappedModal: {
      title: '',
      maxWidth: 'fit-content',
      showCloseBtn: false,
      fullScreen: isMobile,
    },
    verifiedShareModal: {
      title: '',
      showCloseBtn: false,
      maxWidth: 'min(440px, calc(100vw - 32px))',
      width: '100%',
      maxHeight: '90vh',
      height: 'auto',
      centered: true,
      borderRadius: '16px',
      dark: true,
    },
  };

  const componentProps = {
    taskInfoModal: { taskValue: props },
    addTaskModal: { taskValue: props },
    breakModal: {},
    editTaskModal: { taskValue: props, isEditForm: true },
    clientsQueueModal: { calendarQueue: props, isEditForm: true },
    calendarHeaderModal: { calendarProps: props, isEditForm: true },
    calendarSettingsModal: { calendarProps: props },
    planModal: {},
    overlapBookingsModal: { overlapProps: props },
    editServiceModal: { service: props, isEditForm: true },
    editWorkerServiceModal: { service: props},
    createServiceModal: {},
    createWorkerModal: {},
    editWorkerWorkTimeModalOneDay: { workDayValue: props },
    editWorkerNameModal: { worker: props, isEditForm: true },
    editWorkerDescriptionModal: { worker: props, isEditForm: true },
    createWorkerAvatarModal: { callback: callback, isEditForm: false },
    editWorkerAvatarModal: { callback: callback, workerValue: props, isEditForm: true },
    workerClosuresModal: {},
    workerClosuresOneDayModal: { isOneDay: true, dayValue: props },
    workerExtraWorkingTimeModal: {},
    workerExtraWorkingTimeOneDayModal: { isOneDay: true, dayValue: props },
    createSalonAvatarModal: { callback: callback, isEditForm: true },
    createSalonCoverModal: { callback: callback, isEditForm: true },
    clientModal: { client_id: props?.client_id, totPren: props?.totPren },
    refundModal: { refundInformation: props },
    sharedWorkersModal: { callback: callback },
    workerRetailModal: {
      worker: props?.worker,
      modalData: props?.modalData,
      tasks: props?.tasks,
      sOModalData: props?.sOModalData,
      hasOverlappingBookings: props?.hasOverlappingBookings,
      displayedDate: props?.displayedDate,
      queueCount: props?.queueCount,
      canManageChair: props?.canManageChair,
      workerQueue: props?.workerQueue,
    },
    workerSoldOutModal: { modalData: props?.modalData },
    showInfoPaymentModal: { pagamento: props?.pagamento },
    createClientModal: { salone: props },
    qrCodeModal: { activeSalon: props?.activeSalon },
    editSalonIbanModal: { activeSalon: props?.activeSalon },
    workerPaymentDaysModal: { callback: callback, isEditForm: false },
    joinServicesModal: { activeServices: props?.activeServices, worker: props?.worker },
    accountModal: { account: props?.account },
    wrappedModal: { wrappedStats: props?.wrappedStats },
    verifiedShareModal: {},
  };
  const SelectedComponent = useMemo(() => Component[type], [type]);
  if (!SelectedComponent) return null;
  return (
    <Modal
      subTitle={props?.subtitle}
      setIsModalOpen={closeAllModals}
      isModalOpen={true}
      {...(modalProps[type] || {})}
    >
      <SelectedComponent {...(componentProps[type] || {})} closeModal={closeAllModals} />
    </Modal>
  );
};
